import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import toast from "react-hot-toast";

export const generatePDF = () => {
    const button = document.querySelector('.download-pdf-button');
    if (button) button.style.display = 'none'; 
    const element = document.querySelector('.content-page'); 

    // Add a class to the element to apply PDF-specific styles during capture
    if (element) element.classList.add('pdf-capture');

    // Use a fixed windowWidth to ensure desktop-like layout on all devices
    html2canvas(element, { 
        scale: 2, 
        logging: false,
        useCORS: true, 
        windowWidth: 1200, 
        scrollY: -window.scrollY 
    }).then((canvas) => {
        if (element) element.classList.remove('pdf-capture');
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Define margins for the PDF pages
        const marginVert = 15; // 15mm top/bottom
        const marginHoriz = 10; // 10mm left/right
        const drawWidth = pageWidth - (marginHoriz * 2);
        const drawHeight = pageHeight - (marginVert * 2);
        
        // Calculate the height of each slice in canvas pixels
        // based on how much height we have available on the PDF page
        const scaleFactor = drawWidth / canvasWidth;
        const sliceHeight = drawHeight / scaleFactor; 
        
        let yOffset = 0;

        while (yOffset < canvasHeight) {
            if (yOffset > 0) pdf.addPage(); 

            const currentSliceHeight = Math.min(sliceHeight, canvasHeight - yOffset);
            
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvasWidth;
            pageCanvas.height = currentSliceHeight;

            const pageContext = pageCanvas.getContext('2d');
            pageContext.drawImage(
                canvas,
                0, yOffset, 
                canvasWidth, currentSliceHeight, 
                0, 0,
                canvasWidth, currentSliceHeight 
            );

            const pageImgData = pageCanvas.toDataURL('image/jpeg', 1.0);

            // Add the image to the PDF with margins
            pdf.addImage(
                pageImgData, 
                'JPEG', 
                marginHoriz, 
                marginVert, 
                drawWidth, 
                (currentSliceHeight * scaleFactor)
            );

            yOffset += sliceHeight; 
        }

        pdf.save('LicenseInvoice.pdf');
        if (button) button.style.display = 'block'; 
    }).catch((error) => {
        if (element) element.classList.remove('pdf-capture');
        console.error('Error generating PDF:', error);
        toast.error('An error occurred while generating the PDF.');
        if (button) button.style.display = 'block'; 
    });
};
